






























import { Component, Vue, Prop } from 'vue-property-decorator';
import { ElInput } from 'element-ui/types/input';

@Component<PuzzleCalculatorPad>({
  components: {},
})
export default class PuzzleCalculatorPad extends Vue {
  @Prop({ required: true, type: String })
  value!: string;

  $refs!: {
    display: ElInput;
  };
  get valueProxy() {
    return this.value;
  }
  set valueProxy(v: string) {
    if (!/^[0-9+\-*]*$/.test(v)) {
      return;
    }
    this.$emit('input', v);
  }
  clear() {
    this.valueProxy = '';
    this.$emit('clear');
  }
  onBackspace() {
    this.valueProxy = this.valueProxy.slice(0, -1);
  }
}
